<template>
  <section class="pad-t-0 admin-promos-page">
    <div class="bb-container">
      <div class="back">
        <div class="back__back">
          <a @click.prevent="$router.back()">
            <div class="back__name">
              <img
                src="../../assets/img/ico/ico-arrow-back.svg"
                loading="lazy"
                alt="Volver"
                class="back__arrow"
              />
            </div>
          </a>
        </div>
      </div>

      <div class="g-edit" v-show="loaded">
        <div class="g-edit__header">
          <h1 class="g-edit__title">Promociones afiliadas</h1>
          <div class="g-edit__musthave">
            <button class="button button--primary" @click.prevent="goNew">
              Nueva promo
            </button>
          </div>
        </div>

        <div class="filters mar-b-1">
          <div class="filters__row">
            <div class="bb-form-item">
              <div class="bb-form-label">Mercado</div>
              <select v-model="filters.market" class="bb-form" @change="load">
                <option value="">Todos</option>
                <option v-for="m in markets" :key="m" :value="m">{{ m }}</option>
              </select>
            </div>

            <div class="bb-form-item">
              <div class="bb-form-label">Estado</div>
              <select v-model="filters.status" class="bb-form" @change="load">
                <option value="">Todos</option>
                <option value="active">Activa</option>
                <!-- <option value="scheduled">Programada</option>
                <option value="expired">Caducada</option> -->
                <option value="disabled">Desactivada</option>
                <option value="deleted">Eliminada</option>
              </select>
            </div>

            <div class="bb-form-item">
              <div class="bb-form-label">Retailer</div>
              <input
                v-model="filters.retailerName"
                class="bb-form"
                type="text"
                placeholder="Buscar retailer..."
                @keyup.enter="load"
              />
            </div>

            <div class="bb-form-item">
              <div class="bb-form-label">Buscar</div>
              <input
                v-model="filters.q"
                class="bb-form"
                type="text"
                placeholder="Título / cupón / afiliado..."
                @keyup.enter="load"
              />
            </div>
          </div>

          <div class="filters__actions">
            <button class="button button--secondary" @click.prevent="resetFilters">
              Limpiar
            </button>
            <button class="button button--primary" @click.prevent="load">
              Buscar
            </button>
          </div>
        </div>

        <div v-if="errorMsg" class="bb-form-error mar-b-1">{{ errorMsg }}</div>

        <div class="table-wrap">
          <table class="bb-table">
            <thead>
              <tr>
                <th>Estado</th>
                <th>Mercado</th>
                <th>Retailer</th>
                <th>Título</th>
                <th>Cupón</th>
                <th>Vigencia</th>
                <th class="col-actions">Acciones</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="p in promotions" :key="p.id">
                <td>
                  <span class="badge" :class="'badge--' + badgeType(p)">
                    {{ badgeText(p) }}
                  </span>
                </td>
                <td>{{ p.marketCountryIso2 }}</td>
                <td>{{ p.retailerName }}</td>
                <td>
                  <div class="title-cell">
                    <div class="title-cell__title">{{ p.title }}</div>
                    <div class="title-cell__meta">
                      <span v-if="p.scope">{{ p.scope }}</span>
                      <span v-if="p.promotionType"> · {{ p.promotionType }}</span>
                      <span v-if="p.discountPercent != null"> · -{{ p.discountPercent }}%</span>
                      <span v-if="p.discountAmount != null"> · -{{ p.discountAmount }}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span v-if="p.couponType === 'code' && p.couponCode">
                    {{ p.couponCode }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <div class="dates">
                    <div>{{ formatDate(p.startAt) || "—" }}</div>
                    <div>{{ formatDate(p.endAt) || "—" }}</div>
                  </div>
                </td>
                <td class="col-actions">
                  <button class="button button--dark-outline button--sm" @click.prevent="goEdit(p.id)">
                    Editar
                  </button>

                  <!-- <button class="button button--secondary button--sm" @click.prevent="duplicate(p.id)">
                    Duplicar
                  </button> -->

                  <button
                    class="button button--danger-outline button--sm"
                    @click.prevent="disable(p.id)"
                    :disabled="p.status === 'disabled' || p.status === 'deleted'"
                  >
                    Desactivar
                  </button>
                </td>
              </tr>

              <tr v-if="promotions.length === 0">
                <td colspan="7" class="empty">
                  No hay promociones con estos filtros.
                </td>
              </tr>
            </tbody>
          </table>
          <div style="margin-top: 16px; display: flex; justify-content:center;">
            <PaginationAffiliationPromotions
              :page="page"
              :pageSize="pageSize"
              :total="total"
              @change="changePage"
            />
          </div>
        </div>
      </div>

      <div v-if="!loaded" class="mar-t-2">
        <loading-button></loading-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingButton from "../../components/LoadingButton";
import PaginationAffiliationPromotions from "./Pagination.vue";
import axios from "axios";

const API_BASE = process.env.API;

export default {
  name: "AdminAffiliatePromotionsListPage",
  components: { LoadingButton, PaginationAffiliationPromotions },
  data() {
    return {
      loaded: false,
      errorMsg: null,
      promotions: [],
      page: 1,
      pageSize: 10,
      total: 0,
      markets: ["ES", "FR", "IT", "PT", "DE", "NL", "BR", "MX"],
      filters: {
        market: "",
        status: "",
        retailerName: "",
        q: "",
      },
    };
  },
  computed: {
    ...mapGetters({ auth_token: "auth_token" }),
  },
  methods: {
    goNew() {
      this.$router.push({ name: "admin-affiliate-promotions-new" });
    },
    goEdit(id) {
      this.$router.push({ name: "admin-affiliate-promotions-edit", params: { id } });
    },
    resetFilters() {
      this.filters = { market: "", status: "", retailerName: "", q: "" };
      this.load();
    },

    formatDate(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      // formato sencillo, sin i18n por ahora
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },

    isActiveNow(p) {
      if (!p) return false;
      if (p.status && ["disabled", "deleted"].includes(p.status)) return false;

      const now = new Date();
      const startOk = !p.startAt || new Date(p.startAt) <= now;
      const endOk = !p.endAt || new Date(p.endAt) >= now;

      // Si la promo está marcada como expired explícitamente, no la damos como activa
      if (p.status === "expired") return false;

      return startOk && endOk;
    },

    badgeText(p) {
      if (p.status === "disabled") return "Desactivada";
      if (p.status === "deleted") return "Eliminada";
      if (p.status === "expired") return "Caducada";
      if (this.isActiveNow(p)) return "Activa ahora";
      if (p.status === "scheduled") return "Programada";
      if (p.status === "active") return "Activa (pero no vigente)";
      return p.status || "—";
    },

    badgeType(p) {
      if (p.status === "disabled") return "muted";
      if (p.status === "deleted") return "muted";
      if (p.status === "expired") return "warn";
      if (this.isActiveNow(p)) return "ok";
      if (p.status === "scheduled") return "info";
      if (p.status === "active") return "warn";
    },

    async load() {
      this.errorMsg = null;
      try {
        this.loaded = false;

        const params = {};
        params.page = this.page;
        params.pageSize = this.pageSize;
        if (this.filters.market) params.market = this.filters.market;
        if (this.filters.status) params.status = this.filters.status;
        if (this.filters.retailerName) params.retailerName = this.filters.retailerName;
        if (this.filters.q) params.q = this.filters.q;

        console.log("Cargando promociones con filtros", params);

        const res = await axios.get(`${API_BASE}/admin/affiliate-promotions`, {
          params,
          headers: {
            Authorization: `Bearer ${this.auth_token}`
          }
        });

        this.promotions = res.data.items || [];
        this.total = res.data.total || 0;
      } catch (e) {
        this.errorMsg = "No se pudieron cargar las promociones.";
        console.log(e);
      } finally {
        this.loaded = true;
      }
    },

    changePage(newPage) {
      this.page = newPage;
      this.load();
    },

    async duplicate(id) {
      try {
        // Si aún no tienes este endpoint, cambia por PATCH status o elimina el botón
        await this.$axios.post(`/api/admin/affiliate-promotions/${id}/duplicate`);
        await this.load();
      } catch (e) {
        this.errorMsg = "No se pudo duplicar la promoción.";
        console.log(e);
      }
    },

    async disable(id) {
      try {
        // Si aún no tienes este endpoint, usa tu PATCH {id}/status con body {status:'disabled'}


        await axios.patch(`${API_BASE}/admin/affiliate-promotions/${id}/status`,
          { status: 'disabled' },
          { headers: {
            Authorization: `Bearer ${this.auth_token}`
          }
        });

        await this.load();
      } catch (e) {
        this.errorMsg = "No se pudo desactivar la promoción.";
        console.log(e);
      }
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>

<style scoped>
/* Estilos mínimos sin tocar tu theme */
.filters__row {
  display: grid;
  grid-template-columns: 140px 160px 1fr 1fr;
  gap: 12px;
}

.filters__actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.table-wrap {
  overflow-x: auto;
}

.bb-table {
  width: 100%;
  border-collapse: collapse;
}

.bb-table th,
.bb-table td {
  padding: 12px 10px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  vertical-align: top;
}

.col-actions {
  white-space: nowrap;
}

.title-cell__meta {
  font-size: 12px;
  opacity: 0.75;
  margin-top: 2px;
}

.button--sm {
  padding: 8px 10px;
  font-size: 12px;
}

.empty {
  text-align: center;
  padding: 20px 10px;
  opacity: 0.8;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1;
}

.badge--ok {
  background: rgba(40, 167, 69, 0.12);
}

.badge--info {
  background: rgba(23, 162, 184, 0.12);
}

.badge--warn {
  background: rgba(255, 193, 7, 0.18);
}

.badge--muted {
  background: rgba(0, 0, 0, 0.08);
}
</style>
